export default __webpack_public_path__ + "static/media/nav.ce7de146.svg";